import React, { useContext } from "react";
import Space from "components/Space";
import { Button } from "antd";
import styles from "./index.module.scss";
import CourseButton from "components/CourseComponents/CourseButton";
import useModalHandler from "utils/useModalHandler";
import useModalHandlerV3 from "utils/v3/useModalHandler";
import TopicEditor from "../../../../../AskTeacher/Components/TopicEditor";
import CopyModal from "../CopyModal/index.module";
import { CourseContext } from "../../../../Store";
import SetNoticeModal from "../../../../../AskTeacher/Components/SetNoticeModal";
import { BusinessKey } from "../../../../../../service/discuss";

interface HeaderProps {
    count: number;
    onChange(): void;
}

export default function Header({ count, onChange }: HeaderProps) {
    const {
        course: { courseNo, batchNo, courseSeq, weekTimeId }
    } = useContext(CourseContext);

    const addModal = useModalHandler();
    const copyModal = useModalHandler();

    function onAddOk() {
        addModal.close();
        onChange();
    }

    function onCopyOk() {
        copyModal.close();
        onChange();
    }

    const setModal = useModalHandlerV3({
        component: SetNoticeModal
    });

    function openModal() {
        setModal.open({
            businessKey: BusinessKey.Discuss,
            onSuccess: () => setModal.close()
        });
    }

    return (
        <Space className={styles.root}>
            <span className={styles.count}>主题讨论 ({count})</span>
            <Space.Spacer />

            <Space>
                <CourseButton type="add" onClick={addModal.open}>
                    新建讨论
                </CourseButton>

                <Button icon="copy" onClick={copyModal.open}>
                    复制讨论
                </Button>

                {/*<Button icon="setting" onClick={openModal}>*/}
                {/*    设置*/}
                {/*</Button>*/}
            </Space>

            {addModal.render(<TopicEditor title="新建讨论" onOk={onAddOk} />)}

            {copyModal.render(
                <CopyModal
                    courseNo={courseNo}
                    batchNo={batchNo!}
                    courseSeq={courseSeq}
                    weekTimeId={weekTimeId}
                    onOk={onCopyOk}
                />
            )}

            {setModal.render()}
        </Space>
    );
}
